<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">{{ $t('table_title.User') }}</h5>
                            </a-col>
                        </a-row>
                    </template>
                    <template>
                        <v-data-table
                            :headers="tableColumns"
                            :items="folderItems"
                            :page="page"
                            :no-data-text="$t('cms.no_data_available')"
                            :loading="isLoadingFolderItem"
                            :loading-text="$t('cms.loading')"
                            class="elevation-1"
                            hide-default-footer
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-dialog v-model="dialogAdd" persistent max-width="1000px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark class="mr-2" @click="onAddNewItem()" small>
                                                <v-icon small> mdi-plus </v-icon>
                                                {{ $t('cms.add_new') }}
                                            </v-btn>
                                        </template>

                                        <AddUserModal
                                            :isOpen="dialogAdd"
                                            :onAdd="onAddUser"
                                            :onClose="onCloseAdd"
                                            v-if="dialogAdd"
                                        />
                                    </v-dialog>

                                    <v-dialog v-model="dialogEdit" max-width="500px">
                                        <EditUserModal
                                            :cuItem="cuItem"
                                            :formTitle="formTitle"
                                            :closeCU="onCloseEdit"
                                            :save="onEditUser"
                                            :columns="tableColumns"
                                            :dialogEdit="dialogEdit"
                                        >
                                        </EditUserModal>
                                    </v-dialog>

                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <ModalDelete :closeDelete="onCloseDelete" :deleteItemConfirm="onDeleteUser">
                                        </ModalDelete>
                                    </v-dialog>

                                    <v-spacer></v-spacer>

                                    <div class="search">
                                        <a-select :default-value="selectedField" @change="handleChangeSelect">
                                            <a-select-option
                                                v-for="(item, index) in fieldsSearch"
                                                :key="index"
                                                :value="item.value"
                                            >
                                                {{ item.title }}
                                            </a-select-option>
                                        </a-select>
                                        <a-input-search
                                            v-model="search"
                                            :placeholder="$t('header.search')"
                                            @change="onSearchItem"
                                        />
                                    </div>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.avatar`]="{ item }">
                                <div class="my-2">
                                    <v-img :src="item.avatar || noImage" alt="" class="table-image" />
                                </div>
                            </template>
                            <template v-slot:[`item.full_name`]="{ item }">
                                <div class="my-2 line-clamp-1">
                                    <span>{{ item.full_name || '-' }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.email`]="{ item }">
                                <div class="my-2 line-clamp-1">
                                    <span>{{ item.email || '-' }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.gender`]="{ item }">
                                <div class="my-2">
                                    <span>{{ item.gender ? $t(`form.${item.gender.toLowerCase()}`) : '-' }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.role`]="{ item }">
                                <div class="my-2">
                                    <span>{{ item.role ? $t(`form.${item.role.toLowerCase()}`) : '-' }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{
                                        item.created_at_unix_timestamp
                                            ? getFormatDate(+item.created_at_unix_timestamp)
                                            : '-'
                                    }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.updated_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{
                                        item.updated_at_unix_timestamp
                                            ? getFormatDate(+item.updated_at_unix_timestamp)
                                            : '-'
                                    }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <router-link :to="{ path: `/courses-of-user?user_id=${item.id}` }">
                                    <v-btn color="indigo" class="mr-2" dark small>
                                        <v-icon left> mdi mdi-format-list-bulleted-type </v-icon>
                                        {{ $t('cms.record') }}
                                    </v-btn>
                                </router-link>
                                <v-btn color="info" class="mr-2" small @click="onEditItem(item)">
                                    <v-icon small> mdi-pencil </v-icon>
                                    &nbsp;{{ $t('form.edit') }}
                                </v-btn>
                                <v-btn
                                    color="error"
                                    dark
                                    small
                                    @click="onDeleteItem(item)"
                                    v-if="item.id !== userInfo.id"
                                >
                                    <v-icon small> mdi-delete </v-icon>
                                    &nbsp;{{ $t('form.delete') }}
                                </v-btn>
                            </template>
                        </v-data-table>
                        <div class="text-center py-5">
                            <f-pagination
                                v-model="page"
                                :pageSize="folderItemsPagination.pageSize"
                                :totalItems="folderItemsPagination.totalItems"
                                :disabled="isLoadingFolderItem"
                            />
                        </div>
                    </template>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import * as _ from 'lodash';
import { mapState, mapActions } from 'vuex';

import { CRUD } from '../../constants';
import { mixinFormats, mixinToasts, mixinLoadings } from '../../mixins';

import AddUserModal from '../../components/CMS/Modal/AddUserToFolder.vue';
import EditUserModal from '../../components/CMS/Modal/User.vue';
import ModalDelete from '../../components/CMS/Modal/Delete.vue';

export default {
    mixins: [mixinFormats, mixinToasts, mixinLoadings],
    components: { AddUserModal, EditUserModal, ModalDelete },
    data() {
        return {
            // TABLE VARIABLES
            tableColumns: [
                { text: this.$t('form.image'), value: 'avatar', sortable: false, width: '100px' },
                { text: this.$t('form.full_name'), value: 'full_name', sortable: false, width: '150px' },
                { text: this.$t('form.email'), value: 'email', sortable: false, width: '200px' },
                { text: this.$t('form.gender'), value: 'gender', sortable: false, width: '100px' },
                { text: this.$t('form.role'), value: 'role', sortable: false, width: '100px' },
                {
                    text: this.$t('form.created_at'),
                    value: 'created_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                {
                    text: this.$t('form.updated_at'),
                    value: 'updated_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                { text: this.$t('cms.action'), value: 'actions', sortable: false, width: '300px' },
            ],
            page: 1,
            noImage: require('../../assets/images/no_image.jpg'),

            // DIALOG VARIABLES (TYPE BOOLEAN)
            dialogAdd: false,
            dialogEdit: false,
            dialogDelete: false,

            // SEARCH VARIABLES
            fieldsSearch: [
                {
                    title: this.$t('form.full_name'),
                    value: 'full_name',
                },
                {
                    title: this.$t('form.email'),
                    value: 'email',
                },
            ],
            selectedField: 'full_name',
            search: '',

            // OTHER VARIABLES
            cuIndex: -1,
            cuItem: {},
            userInfo: this.$store.getters.getUserInfo,
        };
    },
    computed: {
        ...mapState('folderItem', ['isLoadingFolderItem', 'folderItems', 'folderItemsPagination']),
        formTitle() {
            return this.cuIndex === -1 ? this.$t('cms.new_item') : this.$t('cms.edit_item');
        },
    },
    mounted() {
        this.getUsers({ page: this.page, field: this.selectedField, search: this.search });
    },
    watch: {
        page(val) {
            this.getUsers({ page: val, field: this.selectedField, search: this.search });
        },
        $route: function () {
            this.getUsers({ page: 1, field: this.selectedField, search: this.search });
        },
    },
    methods: {
        ...mapActions('folderItem', ['getItemsFromFolder', 'createMultiItem', 'putItem', 'deleteItem']),

        // -------------------- FUNCTION SHOW / HIDDEN DIALOG ---------------------
        onAddNewItem() {
            this.dialogAdd = true;
        },

        onEditItem(item) {
            this.dialogEdit = true;
            this.cuIndex = this.folderItems.indexOf(item);
            this.cuItem = Object.assign({}, item);
        },

        onDeleteItem(item) {
            this.dialogDelete = true;
            this.cuIndex = this.folderItems.indexOf(item);
            this.cuItem = Object.assign({}, item);
        },

        onCloseAdd() {
            this.dialogAdd = false;
        },

        onCloseEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.cuIndex = -1;
                this.cuItem = {};
            });
        },

        onCloseDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.cuIndex = -1;
                this.cuItem = {};
            });
        },
        // ------------------------------------------------------------------------

        // -------------------- FUNCTION SHOW / HIDDEN DIALOG ---------------------
        async getUsers(data) {
            this.page = data?.page || 1;
            this.selectedField = data?.field || 'full_name';
            this.search = data?.search || '';
            const folder_id = this.$route.query.folder_id;
            const res = await this.getItemsFromFolder({ ...data, folder_id, type: 'USER' });

            if (!res?.isSuccess) {
                this.showError(res?.mess);
            }
        },
        // ------------------------------------------------------------------------

        // -------------------- FUNCTION ADD, EDIT AND DELETE ---------------------
        async onAddUser(userIdList) {
            const folder_id = this.$route.query.folder_id;
            const body = { folder_id, type: 'USER', items: userIdList };

            this.showLoading();

            const res = await this.createMultiItem(body);

            if (res?.isSuccess) {
                await this.getUsers({ page: 1, field: 'full_name', search: '' });
                this.showSuccess(CRUD.CREATE);
            } else {
                this.showError(res?.mess);
            }

            this.hideLoading();
        },

        async onEditUser(callback) {
            this.showLoading();

            const res = await this.putItem({ ...this.cuItem, type: 'USER' });
            callback(res?.isSuccess);
            if (res?.isSuccess) {
                if (res?.data?.id === this.userInfo?.id) {
                    this.$store.dispatch('updateInfo', res?.data);
                }

                await this.getUsers({ page: this.page, field: this.selectedField, search: this.search });

                this.showSuccess(CRUD.UPDATE);
            } else {
                this.showError(res?.mess);
            }

            this.hideLoading();
        },

        async onDeleteUser() {
            this.showLoading();

            const res = await this.deleteItem(this.cuItem?.item_folder_id);

            this.onCloseDelete();

            if (res?.isSuccess) {
                await this.getUsers({ page: this.page, field: this.selectedField, search: this.search });
                this.showSuccess(CRUD.DELETE);
            } else {
                this.showError(res?.mess);
            }

            this.hideLoading();
        },
        // ------------------------------------------------------------------------

        // -------------------- FUNCTION SEARCH ---------------------
        onSearchItem: _.debounce(function (e) {
            this.getUsers({ page: 1, field: this.selectedField, search: this.search });
        }, 500),

        handleChangeSelect(value) {
            this.getUsers({ page: 1, field: value, search: this.search });
        },
        // ----------------------------------------------------------
    },
};
</script>

<style lang="scss">
.table-image {
    width: 45px;
    height: 45px;
}

.search {
    & .ant-select {
        margin-right: 10px;
        width: 120px;
    }

    & .ant-input-search {
        width: 500px;
    }
}
</style>
